module.exports = __webpack_public_path__ + "static/media/1230_Music_R&B_HL.c2b4ea4d.png";